<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Historique des contacts</div>
        <div class="modal-body">
            <div class="tableHisto">
                <h2>Édition des correspondants</h2>
                <frg-table [keysBody]="correspondantBodyTable" [keysColumn]="correspondantColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteCorrespondant($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="isEditCorrepondant"
                    (formSubmit)="changeCorrespondant($event)" (formCancel)="isEditCorrepondant = !isEditCorrepondant"
                    [deleteDuringEdit]="isEditCorrepondant" [loading]="isLoadingCorrespondant" class="expend"></frg-table>
                <div class="buttons-container" *ngIf="!isEditCorrepondant && correspondantBodyTable && correspondantBodyTable.objects && correspondantBodyTable.objects.length > 0">
                    <frg-button (activated)="isEditCorrepondant = !isEditCorrepondant" backgroundColor="var(--darkest-primary)">Editer</frg-button>
                </div>
            </div>
            <hr>
            <div class="tableHisto">
                <h2>Édition des intervenants</h2>
                <frg-table [keysBody]="intervenantBodyTable" [keysColumn]="intervenantColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteIntervenant($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="isEditIntervenant"
                    (formSubmit)="changeIntervenant($event)" (formCancel)="isEditIntervenant = !isEditIntervenant"
                    [deleteDuringEdit]="isEditIntervenant" [loading]="isLoadingIntervenant" class="expend"></frg-table>
                <div class="buttons-container" *ngIf="!isEditIntervenant && intervenantBodyTable && intervenantBodyTable.objects && intervenantBodyTable.objects.length > 0">
                    <frg-button (activated)="isEditIntervenant = !isEditIntervenant" backgroundColor="var(--darkest-primary)">Editer</frg-button>
                </div>
            </div>
            <hr>
            <div class="tableHisto">
                <h2>Édition des contacts personnels</h2>
                <frg-table [keysBody]="personneBodyTable" [keysColumn]="personneColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deletePersonne($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="isEditPersonne"
                    (formSubmit)="changePersonne($event)" (formCancel)="isEditPersonne = !isEditPersonne"
                    [deleteDuringEdit]="isEditPersonne" [loading]="isLoadingPersonne" class='reduce'></frg-table>
                <div class="buttons-container" *ngIf="!isEditPersonne && personneBodyTable && personneBodyTable.objects && personneBodyTable.objects.length > 0">
                    <frg-button (activated)="isEditPersonne = !isEditPersonne" backgroundColor="var(--darkest-primary)">Editer</frg-button>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeHistoRepertoireModal(true)" [type]="'reset'"
                    [backgroundColor]="'var(--darkest-primary)'">Fermer</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>